import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const MainMenu = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");

  useEffect(() => {
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => (prev !== currentLang ? currentLang : prev));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  function openNav() {
    document.getElementById("myNav").style.width = "100%";
  }

  function closeNav() {
    document.getElementById("myNav").style.width = "0";
  }

  function updateLanguage(lang) {
    Cookies.set("RashaLang", lang, { expires: 365 });
    closeNav();
  }

  // 🔁 Translations
  const t = {
    en: {
      home: "Home",
      beauty: "Beauty",
      business: "Business",
      living: "Living",
      gazelle: "Gazelle",
      // referral: "Referral Program",
      arabic: "العربية",
      english: "English",
    },
    ar: {
      home: "الرئيسية",
      beauty: "الجمال",
      business: "الأعمال",
      living: "أسلوب الحياة",
      gazelle: "Gazelle",
      // referral: "برنامج الإحالة",
      arabic: "العربية",
      english: "English",
    },
  };

  const labels = t[language];

  return (
    <div>
      <div className="d-flex justify-content-end w-100">
        <span
          className="icon-menu"
          onClick={openNav}
          role="button"
          tabIndex={0}
        >
          &#9776;
        </span>
      </div>

      <div className="d-flex justify-content-center align-items-center flex-wrap gap-5 main-menu">
        <span onClick={() => navigate("/beauty")}>{labels.beauty}</span>
        <span onClick={() => navigate("/business")}>{labels.business}</span>
        <img
          src="/assets/images/logo/White-Logo.png"
          alt="Logo"
          style={{ height: "290px", width: "290px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        />

        <span onClick={() => navigate("/my-blogs")}>{labels.living}</span>
        <span
          className="label-container"
          onClick={() => window.location.href="https://gazellebyrasha.com/"}
        >
          {labels.gazelle}
          <div className="label-description">a brand by Rasha</div>
        </span>
      </div>

      <div id="myNav" className="overlay">
        <button className="closebtn" onClick={closeNav} aria-label="Close menu">
          &times;
        </button>
        <div className="overlay-content">
          <a href="/">{labels.home}</a>
          <a href="/beauty">{labels.beauty}</a>
          <a href="/business">{labels.business}</a>
          <a href="/my-blogs">{labels.living}</a>
          <a 
            className="label-container"
            href="https://gazellebyrasha.com/"
          >
            {labels.gazelle}
            <div className="label-description-nav">a brand by Rasha</div>
          </a>
          {/* <a href="/">{labels.referral}</a> */}
          <button
            type="button"
            className="lang-button"
            onClick={() => updateLanguage("ar")}
          >
            {labels.arabic}
          </button>
          <button
            type="button"
            className="lang-button"
            onClick={() => updateLanguage("en")}
          >
            {labels.english}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MainMenu;
